import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, TrendingUpIcon, UsersIcon, BarChart2Icon, ClockIcon, BrainIcon, CodeIcon } from 'lucide-react';
export function CaseStudy5() {
  return <div data-id="element-792">
      <section className="bg-gradient-to-r from-[#0096B4] to-[#7DCCD8] text-white py-16" data-id="element-793">
        <div className="container mx-auto px-4" data-id="element-794">
          <Link to="/" className="inline-flex items-center text-white hover:text-[#E0F5F8] mb-6 transition-colors duration-200" data-id="element-795">
            <ArrowLeftIcon size={16} className="mr-1" data-id="element-796" />
            Back to Home
          </Link>
          <h1 className="text-4xl font-bold mb-4" data-id="element-797">
            AI-Driven FinTech Platform
          </h1>
          <p className="text-xl mb-6 text-white max-w-3xl" data-id="element-798">
            How I ideated vision, design and product roadmap of a new AI-driven
            interactive FinTech platform that translates SMB seller data into
            personalized business recommendations. Selected from 45 initiatives
            for expedited global launch by senior leadership.
          </p>
          <div className="flex flex-wrap gap-6 mt-8" data-id="element-799">
            <div className="flex items-center" data-id="element-800">
              <BarChart2Icon size={20} className="mr-2 text-[#E0F5F8]" data-id="element-801" />
              <span className="text-white" data-id="element-802">+24% Program Adoption</span>
            </div>
            <div className="flex items-center" data-id="element-803">
              <TrendingUpIcon size={20} className="mr-2 text-[#E0F5F8]" data-id="element-804" />
              <span className="text-white" data-id="element-805">$145M Projected Growth</span>
            </div>
            <div className="flex items-center" data-id="element-806">
              <ClockIcon size={20} className="mr-2 text-[#E0F5F8]" data-id="element-807" />
              <span className="text-white" data-id="element-808">2-Month Time Savings</span>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-809">
        <div className="container mx-auto px-4" data-id="element-810">
          <div className="max-w-3xl mx-auto" data-id="element-811">
            <div className="mb-12" data-id="element-812">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-813">
                The Challenge
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-814">
                As an MBA intern at Amazon, I was tasked with developing a
                concept to help small-to-medium business (SMB) sellers better
                leverage their transaction data for business growth.
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2" data-id="element-815">
                <li data-id="element-816">
                  Existing tools were underutilized, with adoption rates below
                  industry benchmarks
                </li>
                <li data-id="element-817">
                  SMB customers were struggling to extract actionable insights
                  from their data
                </li>
                <li data-id="element-818">
                  Complex eligibility requirements made it difficult for sellers
                  to qualify for financial programs
                </li>
              </ul>
            </div>
            <div className="mb-12" data-id="element-819">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-820">
                My Approach
              </h2>
              <ol className="list-decimal pl-6 space-y-6" data-id="element-821">
                <li data-id="element-822">
                  <div data-id="element-823">
                    <span className="font-medium text-gray-900" data-id="element-824">
                      Comprehensive User Research
                    </span>
                    <ul className="list-disc pl-6 mt-2 text-gray-700 space-y-1" data-id="element-825">
                      <li data-id="element-826">
                        Conducted interviews with 25+ SMB owners to understand
                        challenges in leveraging data
                      </li>
                      <li data-id="element-827">
                        Created detailed user stories and journey maps to
                        identify friction points in the path to eligibility
                      </li>
                    </ul>
                  </div>
                </li>
                <li data-id="element-828">
                  <div data-id="element-829">
                    <span className="font-medium text-gray-900" data-id="element-830">
                      AI/ML Solution Development
                    </span>
                    <ul className="list-disc pl-6 mt-2 text-gray-700 space-y-1" data-id="element-831">
                      <li data-id="element-832">
                        Specified a random forest machine learning model to
                        analyze transaction patterns and predict loan approval
                        probability
                      </li>
                      <li data-id="element-833">
                        Developed a framework for generating actionable,
                        personalized recommendations based on seller data
                      </li>
                    </ul>
                  </div>
                </li>
                <li data-id="element-834">
                  <div data-id="element-835">
                    <span className="font-medium text-gray-900" data-id="element-836">
                      Cross-Functional Product Roadmap
                    </span>
                    <ul className="list-disc pl-6 mt-2 text-gray-700 space-y-1" data-id="element-837">
                      <li data-id="element-838">
                        Collaborated with engineering, data science, design,
                        marketing, legal, and regulatory teams
                      </li>
                      <li data-id="element-839">
                        Scoped detailed product requirements and prioritized
                        features based on impact vs. effort
                      </li>
                    </ul>
                  </div>
                </li>
              </ol>
            </div>
            <div className="mb-12" data-id="element-840">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-841">
                Solution & Results
              </h2>
              <div className="bg-[#F0FAFC] p-6 rounded-lg mb-8" data-id="element-842">
                <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-843">
                  Key Components of the Solution:
                </h3>
                <ul className="space-y-3" data-id="element-844">
                  <li className="flex" data-id="element-845">
                    <div className="w-2 h-2 rounded-full bg-[#0096B4] mt-2 mr-3" data-id="element-846"></div>
                    <div data-id="element-847">
                      <span className="font-medium text-gray-900" data-id="element-848">
                        AI-Powered Analytics Dashboard
                      </span>
                      <p className="text-gray-700" data-id="element-849">
                        Interactive interface displaying key business metrics
                        with AI-generated insights and personalized
                        recommendations
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-850">
                    <div className="w-2 h-2 rounded-full bg-[#0096B4] mt-2 mr-3" data-id="element-851"></div>
                    <div data-id="element-852">
                      <span className="font-medium text-gray-900" data-id="element-853">
                        Financial Eligibility Roadmap
                      </span>
                      <p className="text-gray-700" data-id="element-854">
                        Step-by-step guidance for implementing recommendations
                        with progress tracking to reach financial program
                        eligibility
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-855">
                    <div className="w-2 h-2 rounded-full bg-[#0096B4] mt-2 mr-3" data-id="element-856"></div>
                    <div data-id="element-857">
                      <span className="font-medium text-gray-900" data-id="element-858">
                        Integrated Notification System
                      </span>
                      <p className="text-gray-700" data-id="element-859">
                        Proactive alerts about new opportunities, eligibility
                        changes, and recommendation updates
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-860">
                Impact:
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-861">
                <div className="bg-[#E0F5F8] p-4 rounded-lg text-center" data-id="element-862">
                  <div className="text-3xl font-bold text-[#0096B4] mb-1" data-id="element-863">
                    +24%
                  </div>
                  <div className="text-sm text-gray-700" data-id="element-864">Program Adoption</div>
                </div>
                <div className="bg-[#E0F5F8] p-4 rounded-lg text-center" data-id="element-865">
                  <div className="text-3xl font-bold text-[#0096B4] mb-1" data-id="element-866">
                    $145M
                  </div>
                  <div className="text-sm text-gray-700" data-id="element-867">
                    Projected Revenue Impact
                  </div>
                </div>
                <div className="bg-[#E0F5F8] p-4 rounded-lg text-center" data-id="element-868">
                  <div className="text-3xl font-bold text-[#0096B4] mb-1" data-id="element-869">
                    -2 Months
                  </div>
                  <div className="text-sm text-gray-700" data-id="element-870">
                    Time to Loan Eligibility
                  </div>
                </div>
              </div>
              <p className="text-gray-700" data-id="element-871">
                My AI-driven platform concept was selected for expedited global
                launch from among 45 competing initiatives by senior leadership.
                The Product Requirements Document (PRD) was approved as-is
                without revisions—a rare achievement that highlighted the
                thoroughness of my approach. The platform was projected to
                increase program adoption by 24%, translating to $145M in
                additional revenue, while reducing the average time to reach
                loan eligibility by 2 months.
              </p>
            </div>
            <div data-id="element-872">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-873">
                Key Learnings
              </h2>
              <ol className="list-decimal pl-6 space-y-4" data-id="element-874">
                <li data-id="element-875">
                  <div data-id="element-876">
                    <span className="font-medium text-gray-900" data-id="element-877">
                      User-centered design creates compelling solutions
                    </span>
                    <p className="text-gray-700" data-id="element-878">
                      The comprehensive user research validated the market need
                      and ensured the solution directly addressed real pain
                      points, leading to projected high adoption rates.
                    </p>
                  </div>
                </li>
                <li data-id="element-879">
                  <div data-id="element-880">
                    <span className="font-medium text-gray-900" data-id="element-881">
                      AI/ML technology enables personalization at scale
                    </span>
                    <p className="text-gray-700" data-id="element-882">
                      The machine learning model allowed for individualized
                      recommendations based on specific seller data patterns,
                      creating value that generic solutions couldn't match.
                    </p>
                  </div>
                </li>
                <li data-id="element-883">
                  <div data-id="element-884">
                    <span className="font-medium text-gray-900" data-id="element-885">
                      Cross-functional alignment drives successful product
                      development
                    </span>
                    <p className="text-gray-700" data-id="element-886">
                      By coordinating across multiple disciplines and securing
                      stakeholder buy-in early, we created a solution that
                      addressed business, technical, and regulatory requirements
                      simultaneously.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="py-12 bg-[#F0FAFC]" data-id="element-887">
        <div className="container mx-auto px-4" data-id="element-888">
          <div className="max-w-3xl mx-auto" data-id="element-889">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-890">
              More Case Studies
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-891">
              <Link to="/case-study-6" className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200" data-id="element-892">
                <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-893">
                  Product Innovation & Development
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-894">
                  Rebuilt a pre-launch product with low retailer buy-in by
                  co-creating with KOLs.
                </p>
                <span className="text-[#0096B4] font-medium" data-id="element-895">
                  Read case study →
                </span>
              </Link>
              <Link to="/case-study-9" className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200" data-id="element-896">
                <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-897">
                  DTC Product Selection Quiz
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-898">
                  Rebuilt a DTC guided selling tool by analyzing consumer
                  path-to-purchase and optimizing the algorithm.
                </p>
                <span className="text-[#0096B4] font-medium" data-id="element-899">
                  Read case study →
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}